<div #mapContainer style="width: 100%; height: 400px;" class="parking-map" [class.map-error]="mapValidationError">
    <button *ngIf="!readonly" type="button" class="btn btn-danger clear " (click)="clearMap()">
    <i class="fa-solid fa-broom"></i>
  </button>
</div>
